export enum TabNames {
  Properties = "Properties",
  Timeline = "Timeline",
  ConnectedAgreement = "Connected Agreement",
  RequirementVersions = "Requirement Versions",
  GeneralInfo = "General Info ",
  People = "People",
  Log = "Log",
}
export enum PropertyTabNames {
  PropertiesInDraftMode = "Properties in Draft Mode",
  ProposedPropertyList = "Proposed Property List",
  CSLInitial = "CSL - Initial",
  SiteVisit = "Site Visit",
  CSLFinal = "CSL - Final",
  TermSheetSubmission = "Term Sheet Submission",
  FeeConfirmation = "Fee Confirmation",
  LetterofIntent = "Letter of Intent",
  LegalDueDiligence = "Legal Due Diligence",
}

export enum PropertyDetailTabNames {
  Overview = "Overview",
  UnitInfo = "Unit/Tenant Info",
  LocationMap = "Location Map",
  Log = "Log",
}

export enum ViewTypes {
  List = "List",
  Occupation = "Occupation",
  Timeline = "Timeline",
}

export enum StatusTab {
  Requested = "Requested",
  Approved = "Approved",
  Edited = "Edited",
  Rejected = "Rejected",
  Deleted = "Deleted",
}

export enum UploadTabNames {
  TimesheetInProgess = "Timesheet In Progess",
  SignedTimesheet = "Signed Timesheet",
  TimesheetVersion = "Timesheet Version",
  SignedTimesheetVersion = "Signed Timesheet Version",
}

export enum FeeConfirmationTabNames {
  ClientFeeConfirmation = " Client Fee Confirmation",
  LandLordFeeConfirmation = "LandLordFeeConfirmation",
  Version = "Version",
}
